export default __webpack_public_path__ + "static/media/logo-small.5f872b9a.svg";